// extracted by mini-css-extract-plugin
module.exports = {"section":"ProfileSections_section__3kvrH","title":"ProfileSections_title__3nWYb"};